export default __webpack_public_path__ + "static/media/gallery-comparison_00.5cd0cdc6.jpg";